import { render, staticRenderFns } from "./FontSizeDropdown.vue?vue&type=template&id=48e8063c&scoped=true"
import script from "./FontSizeDropdown.vue?vue&type=script&lang=js"
export * from "./FontSizeDropdown.vue?vue&type=script&lang=js"
import style0 from "./FontSizeDropdown.vue?vue&type=style&index=0&id=48e8063c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e8063c",
  null
  
)

export default component.exports